import { Ticket, TicketStatus } from '../../../entities/ticket/model/types';
import { updateTicket as updateTicketApi } from '../../../entities/ticket/api/ticketApi';

export interface UpdateTicketStatusRequest {
  ticketId: string;
  status: TicketStatus;
}

export class UpdateTicketStatusUseCase {
  async execute(request: UpdateTicketStatusRequest): Promise<Ticket> {
    return await updateTicketApi(request.ticketId, { status: request.status });
  }
}




